import { OptionalVFATests, TestCategory } from "types/tests";

export const SCOPE_TYPE = {
  testSession: "testSession",
  testSuiteEdit: "testSuiteEdit",
  testSuiteOverview: "testSuiteOverview",
  installer: "installer",
  oldUI: "oldUI",
  newUI: "newUI",
  dataExport: "dataExport",
  darkMode: "darkMode",
  dicom: "dicom",
  middleCalibration: "middleCalibration",
  translation: "translation",
  vfaAdvancedMetrics: "vfaAdvancedMetrics",
  vfaAdaptiveTracking: "vfaAdaptiveTracking",
  vfaPattern24_2C: "vfaPattern24_2C",
  screenStreaming: "screenStreaming",
  virtualAssistantWebView: "virtualAssistantWebView",
  reliabilityAutoRestart: "reliabilityAutoRestart",
  eyeImages: "eyeImages",
  extraocularMuscleFunction: "extraocularMuscleFunction",
  antiSaccade: "antiSaccade",
  raTextEditor: "raTextEditor",
  ...TestCategory,
  ...OptionalVFATests,
};
